@if (billingRunTypeSepaChargesWidgetData && initialized) {
    <mvs-widget [widgetData]="billingRunTypeSepaChargesWidgetData"></mvs-widget>
}
